module.exports = __webpack_public_path__ + "static/media/dark_blue-cluster.1e69f2b9.svg";